<template>
  <div
    v-if="variant === 'menu'"
    class="flex w-full items-center justify-between px-3 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100/80 dark:hover:bg-gray-700/60 rounded-md transition-colors cursor-pointer select-none"
    @click="themeStore.toggle()"
  >
    <div class="flex items-center gap-3">
      <Moon
        v-if="!themeStore.isDark"
        :size="18"
        class="text-gray-600 dark:text-gray-300"
      />
      <Sun
        v-else
        :size="18"
        class="text-gray-600 dark:text-gray-300"
      />
      <span class="font-normal text-gray-800 dark:text-gray-200">{{ $t('COMMON.DARK_MODE') }}</span>
    </div>
    <el-switch
      :model-value="themeStore.isDark"
      size="large"
      class="pointer-events-none"
    />
  </div>

  <div
    v-else-if="variant === 'switcher'"
    class="inline-flex h-7 w-[60px] shrink-0 items-center rounded-full border border-gray-300 bg-gray-100 p-0.5 dark:border-gray-600 dark:bg-gray-700"
  >
    <button
      type="button"
      class="flex h-6 flex-1 items-center justify-center rounded-full transition-colors"
      :class="!themeStore.isDark
        ? 'bg-blue-100 text-blue-600 shadow-sm dark:bg-blue-900/70 dark:text-blue-300'
        : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'"
      :aria-label="$t('COMMON.LIGHT_MODE')"
      :title="$t('COMMON.LIGHT_MODE')"
      :aria-pressed="!themeStore.isDark"
      @click.stop="themeStore.setTheme('light')"
    >
      <Sun :size="14" />
    </button>
    <button
      type="button"
      class="flex h-6 flex-1 items-center justify-center rounded-full transition-colors"
      :class="themeStore.isDark
        ? 'bg-blue-100 text-blue-600 shadow-sm dark:bg-blue-900/70 dark:text-blue-300'
        : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'"
      :aria-label="$t('COMMON.DARK_MODE')"
      :title="$t('COMMON.DARK_MODE')"
      :aria-pressed="themeStore.isDark"
      @click.stop="themeStore.setTheme('dark')"
    >
      <Moon :size="14" />
    </button>
  </div>

  <el-button
    v-else
    text
    @click="themeStore.toggle()"
  >
    <Moon
      v-if="!themeStore.isDark"
      :size="20"
    />

    <Sun
      v-else
      :size="20"
    />
  </el-button>
</template>

<script setup lang="ts">
import {
  Moon,
  Sun,
} from "@lucide/vue";
import {
  useThemeStore,
} from "~/stores/theme";

withDefaults(
  defineProps<{
    variant?: "icon" | "menu" | "switcher";
  }>(),
  {
    variant: "icon",
  },
);

const themeStore = useThemeStore();
</script>
